import React from 'react';
import { connect } from 'react-redux';
import { isTestEnvironment } from '../../config';
import { logout } from '../../redux/actions/login';
import { cookie } from '../../utils/cookie/cookie';

const TIMEOUT: number = 1500;
const SESSION_COOKIE: string = '_wmp_UIDX';

interface Props {
  logout(): void;
}

export class SessionCheckerComponent extends React.PureComponent<Props> {
  private intervalId: number;

  public componentDidMount() {
    this.intervalId = window.setInterval(this.checkCookie.bind(this), TIMEOUT);
  }

  public componentWillUnmount() {
    if (this.intervalId) {
      window.clearInterval(this.intervalId);
    }
  }

  public checkCookie() {
    const isSessionCookieEmpty: boolean = !cookie.find(SESSION_COOKIE);

    if (isSessionCookieEmpty && !isTestEnvironment()) {
      this.props.logout();
      window.clearInterval(this.intervalId);
    }
  }

  public render() {
    return null;
  }
}

const mapDispatchToProps = {
  logout,
};

export const SessionChecker = connect<any, any, any>(
  null,
  mapDispatchToProps,
)(SessionCheckerComponent);
